import React, { useEffect, useState } from 'react';
import { Area, RedBed, RedMapPin } from 'assets/images/web-isn';
import { formatMoney, formatterUSD } from 'utils/objects';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useTranslation } from 'react-i18next';
import { handleDateLocale } from './formatDate';
//import { useParams } from 'react-router-dom';

function OverviewPayment(props) {
  const { t } = useTranslation();
  const { apartmentDetail, startDate, endDate, getNight, getPrice } = props;
  const { currentCurrency } = props.layout;
  //const { language } = useParams();
  const [night, setNight] = useState(0);
  const [localCurrency, setLocalCurrency] = useState(0);
  const [charges, setCharges] = useState(0);

  useEffect(() => {
    let difference = endDate?.getTime() - startDate?.getTime();
    let days = Math.round(difference / (1000 * 60 * 60 * 24));
    if (!isNaN(days)) {
      setNight(days);

      if (getNight !== undefined) {
        getNight(days);
      }
    }

    if (endDate === null) {
      setNight(0);
    }

    //eslint-disable-next-line
  }, [startDate, endDate]);

  useEffect(() => {
    if (night > 0) {
      setLocalCurrency(apartmentDetail?.priceViEquals * night + (apartmentDetail?.priceViEquals * night * 10) / 100);

      if (getPrice !== undefined) {
        getPrice(apartmentDetail?.priceViEquals * night + (apartmentDetail?.priceViEquals * night * 10) / 100);
      }
    }

    if (currentCurrency?.code === 'USD' && apartmentDetail?.priceOffer && apartmentDetail?.isOffer === true) {
      setCharges(apartmentDetail.priceOffer * night);
    } else if (
      currentCurrency?.code === 'USD' &&
      apartmentDetail?.priceEquals &&
      (apartmentDetail?.isOffer === false || (apartmentDetail?.isOffer && !apartmentDetail?.priceOffer))
    ) {
      setCharges(apartmentDetail.priceEquals * night);
    } else if (currentCurrency?.code === 'VND' && apartmentDetail?.priceOfferVi && apartmentDetail?.isOffer === true) {
      setCharges(apartmentDetail.priceOfferVi * night);
    } else if (
      currentCurrency?.code === 'VND' &&
      apartmentDetail?.priceViEquals &&
      (apartmentDetail?.isOffer === false || (apartmentDetail?.isOffer && !apartmentDetail?.priceOfferVi))
    ) {
      setCharges(apartmentDetail.priceViEquals * night);
    }
    //eslint-disable-next-line
  }, [night, currentCurrency, apartmentDetail]);

  const getCharges = () => {
    if (currentCurrency?.code === 'USD' && apartmentDetail?.priceOffer && apartmentDetail?.isOffer === true) {
      return `${currentCurrency?.symbol}${formatMoney(apartmentDetail?.priceOffer, 0, 0)}`;
    } else if (
      currentCurrency?.code === 'USD' &&
      apartmentDetail?.priceEquals &&
      (apartmentDetail?.isOffer === false || (apartmentDetail?.isOffer && !apartmentDetail?.priceOffer))
    ) {
      return `${currentCurrency?.symbol}${formatMoney(apartmentDetail?.priceEquals, 0, 0)}`;
    } else if (currentCurrency?.code === 'VND' && apartmentDetail?.priceOfferVi && apartmentDetail?.isOffer === true) {
      return `${formatMoney(apartmentDetail?.priceOfferVi, 0, 0)}${currentCurrency?.symbol}`;
    } else if (
      currentCurrency?.code === 'VND' &&
      apartmentDetail?.priceViEquals &&
      (apartmentDetail?.isOffer === false || (apartmentDetail?.isOffer && !apartmentDetail?.priceOfferVi))
    ) {
      return `${formatMoney(apartmentDetail?.priceViEquals, 0, 0)}${currentCurrency?.symbol}`;
    } else {
      return;
    }
  };

  return (
    <div className="booking-info col-12 col-lg-6">
      <div className="booking-info__content">
        <div className="booking-info__content--title">{apartmentDetail?.projectName}</div>
        <div className="booking-info__content--booking">
          <div className="container">
            <div className="row d-block d-lg-flex">
              <div className="col-lg-5 col-12">
                <img
                  className="booking-info__content--booking_img"
                  src={`${process.env.REACT_APP_ISN_IMAGE_URL}${apartmentDetail?.images[0].url}`}
                  alt=""
                />
              </div>
              <div className="col-lg-7 col-12">
                <div className="booking-info__content--booking_title mt-3 mt-lg-0">{apartmentDetail?.name}</div>
                <div className="booking-info__content--booking_apartment-info d-flex flex-column">
                  <div className="d-flex justify-content-between pd-20px">
                    <div className="d-flex align-items-center">
                      <img className="map-pin" src={RedMapPin} alt="map-pin" />
                      <span>{apartmentDetail?.district}</span>
                    </div>
                    <div className="d-flex align-items-center">
                      <img className="bedrooms" src={RedBed} alt="bedrooms" />
                      <span>{apartmentDetail?.bedRoomName}</span>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between">
                    <div>
                      <div className="price-per-day">
                        {getCharges()}
                        <span className="text-night">/{t('offers.label_day')}</span>
                      </div>
                      {apartmentDetail?.isOffer === true ? (
                        <div className="price-per-day" style={{ color: '#6b6b6b' }}>
                          <span className="focus-price" style={{ textDecoration: 'line-through' }}>
                            {currentCurrency?.code === 'USD' &&
                            apartmentDetail?.isOffer === true &&
                            apartmentDetail?.priceOffer > 0
                              ? `${currentCurrency?.symbol}${formatMoney(apartmentDetail?.price, 0, 0)}/${t(
                                  'offers.label_day',
                                )}`
                              : ''}
                            {currentCurrency?.code === 'VND' &&
                            apartmentDetail?.isOffer === true &&
                            apartmentDetail?.priceOfferVi > 0
                              ? `${formatMoney(apartmentDetail?.priceVi, 0, 0)}${currentCurrency?.symbol}/${t(
                                  'offers.label_day',
                                )}`
                              : ''}
                          </span>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                    <div className="d-flex align-items-center">
                      <img className="area" src={Area} alt="Area" />
                      <span className="d-flex">
                        {apartmentDetail?.size}
                        m<sup style={{ top: '4px' }}>2</sup>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {startDate ? (
              <>
                <div className="draw-border"></div>
                <div className="d-flex flex-column check-date">
                  <div className="d-flex justify-content-between">
                    <div className="d-flex">
                      <div>
                        <div className="check-date_title">{t('payment.label_checkIn')}</div>
                        {startDate ? (
                          <div className="check-date_info">
                            {handleDateLocale(startDate)}
                            <div className="time-check-in-out">(14:00 GMT+7)</div>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                    <div className="d-flex">
                      <div>
                        <div className="check-date_title">{t('payment.label_checkOut')}</div>
                        {endDate ? (
                          <div className="check-date_info">
                            {handleDateLocale(endDate)}
                            <div className="time-check-in-out">(12:00 GMT+7)</div>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                    <div className="d-flex">
                      <div>
                        <div className="check-date_title">
                          {t('payment.label_night')}
                          {/* {night > 0 ? 'Nights' : 'Night'} */}
                        </div>
                        {startDate && endDate ? (
                          <div className="check-date_info d-flex justify-content-end">{night}</div>
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ''
            )}

            {night > 0 ? (
              <>
                <div className="draw-border"></div>
                <div className="d-flex flex-column payment-details">
                  <div className="d-flex justify-content-between payment-details__pd-bottom">
                    <div className="d-flex payment-details__font-bold">{t('payment.label_paymentDetail')}</div>
                  </div>
                  <div className="d-flex justify-content-between payment-details__pd-bottom">
                    <div className="d-flex">{t('payment.label_charges')}</div>
                    <div className="d-flex">
                      {currentCurrency?.code === 'USD'
                        ? `${currentCurrency?.symbol}${formatterUSD.format(charges)}`
                        : `${formatMoney(charges, 0, 0)}${currentCurrency?.symbol}`}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between payment-details__pd-bottom">
                    <div className="d-flex">{t('payment.label_VAT')}</div>
                    <div className="d-flex">
                      {/* {console.log(format1((charges * 10) / 100, '$'))} */}
                      {currentCurrency?.code === 'USD'
                        ? `${currentCurrency?.symbol}${formatterUSD.format((charges * 10) / 100)}`
                        : `${formatMoney((charges * 10) / 100, 0, 0)}${currentCurrency?.symbol}`}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between payment-details__pd-bottom">
                    <div className="d-flex">{t('payment.label_total')}</div>
                    <div className="d-flex">
                      {currentCurrency?.code === 'USD'
                        ? `${currentCurrency?.symbol}${formatterUSD.format(charges + (charges * 10) / 100)}`
                        : `${formatMoney(charges + (charges * 10) / 100, 0, 0)}${currentCurrency?.symbol}`}
                        {currentCurrency?.code === 'USD' ? <span className="font-red">&nbsp;*</span> : ''}
                    </div>
                  </div>
                  <div className="d-flex justify-content-between payment-details__pd-bottom">
                    <div className="d-flex payment-details__font-bold">{t('payment.label_localCurrency')}</div>
                    <div className="d-flex payment-details__font-bold">
                      {formatMoney(localCurrency, 0, 0)}đ{' '}
                    </div>
                  </div>
                  {currentCurrency?.code === 'USD' ? (
                    <div className="font-red">{t('payment.label_localCurDes')}</div>
                  ) : (
                    ''
                  )}
                </div>
              </>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStatetoProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStatetoProps, mapDispatchToProps)(OverviewPayment);
